export default __webpack_public_path__ + "static/media/hero_5.22062ad0.png";